'use client';

import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

interface CheckboxProps extends React.ComponentProps<
    typeof CheckboxPrimitive.Root
> {
    size?: 'sm' | 'md';
}

function Checkbox({ className, size = 'md', ...props }: CheckboxProps) {
    const sizeClass = size === 'sm' ? 'size-3.5' : 'size-4';
    const iconClass = size === 'sm' ? 'size-3' : 'size-3.5';

    return (
        <CheckboxPrimitive.Root
            data-slot="checkbox"
            className={cn(
                'peer border bg-input-background dark:bg-input/30 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-hidden focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
                sizeClass,
                className
            )}
            {...props}
        >
            <CheckboxPrimitive.Indicator
                data-slot="checkbox-indicator"
                className="flex items-center justify-center text-current transition-none"
            >
                <CheckIcon className={iconClass} />
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
    );
}

export { Checkbox };
